import SessionReplay, { LDRecord } from '@launchdarkly/session-replay';

import { CILogger } from 'common/log/log.provider';

/** `strict` obfuscates all text and images; `manualStart` records nothing until asked. */
export const createSessionReplayPlugin = (): SessionReplay =>
    new SessionReplay({
        manualStart: true,
        privacySetting: 'strict',
    });

const getRecordingState = (): string | undefined => {
    try {
        return LDRecord.getRecordingState() as string;
    } catch {
        // Plugin not registered yet.
        return undefined;
    }
};

export const isSessionReplayRecording = (): boolean => getRecordingState() === 'Recording';

export const startSessionReplay = async (): Promise<void> => {
    if (isSessionReplayRecording()) {
        return;
    }

    try {
        await LDRecord.start();
    } catch (error) {
        CILogger.getInstance().error('[LaunchDarkly] session replay failed to start', error);
    }
};

export const stopSessionReplay = (): void => {
    try {
        LDRecord.stop();
    } catch (error) {
        CILogger.getInstance().error('[LaunchDarkly] session replay failed to stop', error);
    }
};
